import React from 'react';

import ImageSlider from '../components/ImageSlider';
import LatestArticle from '../components/LatestArticle';
import CalendarUser from '../components/Calendar';
export default function Home() {
    return (
        <div>
             
            
            <div className="container">
           
                <ImageSlider />
                

                    
                    
                   
                    
                    <LatestArticle />
                    
               
                     

                

                
                
                
                
            </div>

            <div className="container">
                <div className="row">
                    <CalendarUser />
                </div>
            </div>
            
        </div>
    )
}
